import React, { useContext, useEffect } from "react";

import { EmailContext } from "../context/store";
import { submitEmail } from "../actions";
import MailIcon from "./icons/Mail";
import validator from "validator";

// "inline" is the wide navbar strip; "stacked" is the sidebar card, which has
// to fit the 220px left column.
export default function EmailSubmit({ variant = "inline" }) {
  const [email, emailDispatch] = useContext(EmailContext);
  function handleChange(e) {
    //Validation happens on submit
    emailDispatch({ email: e.target.value, isValid: true, submitted: false });
  }
  function handleClick(e) {
    if (!validator.isEmail(email.email)) {
      emailDispatch({ isValid: false, email: "", submitted: false });
    } else {
      emailDispatch({ isValid: true, email: email.email, submitted: true });
      submitEmail(email.email);
    }
  }
  // Clear once submitted
  useEffect(() => {
    let timeout;
    if (email.submitted) {
      timeout = setTimeout(() => {
        emailDispatch({ isValid: true, email: "", submitted: false });
      }, 1400);
    }
    if (!email.isValid) {
      timeout = setTimeout(() => {
        emailDispatch({
          isValid: true,
          email: "",
          submitted: false
        });
      }, 1700);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [email]);

  const CTAStyle = {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    alignSelf: "right"
  };
  const CTATextStyle = {
    color: "white",
    paddingRight: "10px"
  };
  const inputStyle = { paddingRight: "10px" };
  const buttonStyle = { marginLeft: "10px" };
  const validationStyle = {
    paddingLeft: "10px",
    color: email.submitted ? "#daffba" : email.isValid ? "white" : "#d03234"
  };
  function handleEnter(e) {
    if (e.keyCode == 13) {
      handleClick(e);
    }
  }

  const message = email.submitted
    ? "You'll hear from us soon!"
    : !email.isValid
    ? "Invalid email"
    : "";

  if (variant === "stacked") {
    return (
      <StackedCard
        email={email}
        message={message}
        onChange={handleChange}
        onEnter={handleEnter}
        onSubmit={handleClick}
      />
    );
  }

  return (
    <div style={CTAStyle}>
      <span style={CTATextStyle}>Want it on mobile? Get notified:</span>
      <div>
        <input
          style={inputStyle}
          placeholder="email@example.com"
          onChange={handleChange}
          value={email.email}
          onKeyDown={handleEnter}
        />
        <button style={buttonStyle} className="button" onClick={handleClick}>
          Submit
        </button>
        <span style={validationStyle}>{message}</span>
      </div>
    </div>
  );
}

function StackedCard({ email, message, onChange, onEnter, onSubmit }) {
  const cardStyle = {
    background: "#31404a",
    borderRadius: "6px",
    padding: "12px"
  };
  const headingStyle = {
    display: "flex",
    alignItems: "center",
    color: "white",
    fontSize: ".8rem",
    fontWeight: "600"
  };
  const blurbStyle = {
    color: "#aebac1",
    fontSize: ".7rem",
    fontWeight: "400",
    lineHeight: "1.35",
    margin: ".4rem 0 .6rem 0"
  };
  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: ".35rem .4rem",
    border: "1px solid #8fa0a8",
    borderRadius: "3px"
  };
  const buttonStyle = {
    width: "100%",
    marginTop: ".4rem",
    padding: ".35rem 0",
    color: "white",
    background: "#29945c",
    border: "none",
    borderRadius: "3px",
    cursor: "pointer",
    fontWeight: "600"
  };
  // Reserve the line so the card doesn't jump when validation text appears.
  const messageStyle = {
    minHeight: "1rem",
    marginTop: ".3rem",
    fontSize: ".7rem",
    fontWeight: "400",
    color: email.submitted ? "#daffba" : email.isValid ? "white" : "#d03234"
  };

  return (
    <div style={cardStyle}>
      <div style={headingStyle}>
        <MailIcon size={16} fill="#6fbcff" />
        <span style={{ marginLeft: "8px" }}>Get it on mobile</span>
      </div>
      <div style={blurbStyle}>We'll email you when the mobile app is ready.</div>
      <input
        style={inputStyle}
        placeholder="email@example.com"
        onChange={onChange}
        value={email.email}
        onKeyDown={onEnter}
      />
      <button style={buttonStyle} className="button" onClick={onSubmit}>
        Submit
      </button>
      <div style={messageStyle}>{message}</div>
    </div>
  );
}
